<template>
    <a-modal v-model:visible="visable" title="编辑商户" width="50%" centered :confirmLoading="loading" @ok="doValidate">
        <a-form-model ref="formRef" :model="formData" label-position="top">
            <a-row :gutter="12">
                <!-- 图片上传 -->
                <a-col :span="4">
                    <a-form-model-item label="商家图片" prop="thumb">
                        <thumb v-model="formData.thumb" :size="1" :width="140" :height="140" />
                    </a-form-model-item>
                </a-col>
                <!-- 商户名称 -->
                <a-col :span="8">
                    <a-form-model-item label="商户名称" prop="name" :rules="{ required: true, message: '请输入商户名称' }">
                        <a-input v-model="formData.name" placeholder="请输入商户名称" />
                    </a-form-model-item>
                </a-col>
                <!-- 所属分类 -->
                <a-col :span="4">
                    <a-form-model-item label="所属分类" prop="cateId" :rules="{ required: true, message: '请选择所属分类' }">
                        <a-select v-model="formData.cateId" placeholder="请选择所属分类">
                            <a-select-option :value="item.cateId" v-for="item in categorys" :key="item.cateId">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <!-- 所在区域 -->
                <a-col :span="4">
                    <a-form-model-item label="所在区域" prop="areaId" :rules="{ required: true, message: '请选择所在区域' }">
                        <a-select v-model="formData.areaId" placeholder="请选择所在区域">
                            <a-select-option :value="item.areaId" v-for="item in areas" :key="item.areaId">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <!-- 铺位号 -->
                <a-col :span="4">
                    <a-form-model-item label="铺位号" prop="no" :rules="{ required: false, message: '请输入铺位号' }">
                        <a-input v-model="formData.no" placeholder="请输入铺位号" />
                    </a-form-model-item>
                </a-col>
                <!-- 所属单位 -->
                <a-col :span="8">
                    <a-form-model-item label="所属单位" prop="organId" :rules="[{ required: true, message: '请选择所属单位' }]">
                        <choose-organ v-model="formData.organId" :allowClear="true"></choose-organ>
                    </a-form-model-item>
                </a-col>
                <!-- 营业执照号码 -->
                <a-col :span="4">
                    <a-form-model-item label="营业执照号码" prop="identifier"
                        :rules="{ required: false, message: '请输入营业执照号码' }">
                        <a-input v-model="formData.identifier" placeholder="请输入营业执照号码" />
                    </a-form-model-item>
                </a-col>
                <!-- 负责人 -->
                <a-col :span="4">
                    <a-form-model-item label="负责人" prop="person" :rules="{ required: true, message: '请输入负责人' }">
                        <a-input v-model="formData.person" placeholder="负责人姓名" />
                    </a-form-model-item>
                </a-col>
                <!-- 联系电话 -->
                <a-col :span="4">
                    <a-form-model-item label="负责人电话" prop="phone" :rules="{ required: true, message: '请输入负责人电话' }">
                        <a-input v-model="formData.phone" placeholder="请输入负责人电话" />
                    </a-form-model-item>
                </a-col>
                <!-- 地址 -->
                <a-col :span="8">
                    <a-form-model-item label="地址" prop="address" :rules="{ required: true, message: '请输入地址' }">
                        <a-input v-model="formData.address" placeholder="请输入地址" />
                    </a-form-model-item>
                </a-col>
                <!-- 导购员电话 -->
                <a-col :span="8">
                    <a-form-model-item label="导购员电话" prop="saleMobile">
                        <a-select mode="tags" style="width: 100%" :maxTagCount="1"
                            v-model="formData.saleMobile"></a-select>
                    </a-form-model-item>
                </a-col>
                <!-- 品牌 -->
                <a-col :span="4">
                    <a-form-model-item label="品牌" prop="brand">
                        <a-input v-model="formData.brand" placeholder="请输入品牌" />
                    </a-form-model-item>
                </a-col>
                <!-- 品牌Logo -->
                <a-col :span="4">
                    <a-form-model-item label="品牌Logo" prop="brandLogo">
                        <thumb v-model="formData.brandLogo" :size="1" :width="140" :height="140" />
                    </a-form-model-item>
                </a-col>
                <!-- 商家小程序 -->
                <a-col :span="4">
                    <a-form-model-item label="商家小程序" prop="wechatApp">
                        <a-input v-model="formData.wechatApp" placeholder="商家小程序APPID" />
                    </a-form-model-item>
                </a-col>
                <!-- 备注 -->
                <a-col :span="8">
                    <a-form-model-item label="备注" prop="remark">
                        <a-input v-model="formData.remark" :max-length="200" placeholder="请输入备注" />
                    </a-form-model-item>
                </a-col>
                <!-- 国补名额 -->
                <a-col :span="2">
                    <a-form-model-item label="国补名额" prop="guobuNum">
                        <a-input-number v-model="formData.guobuNum" :min="0" placeholder="国补名额" style="width: 100%;" />
                    </a-form-model-item>
                </a-col>
                <!-- 排序 -->
                <a-col :span="2">
                    <a-form-model-item label="排序" prop="sort">
                        <a-input-number v-model="formData.sort" :min="0" placeholder="排序值" style="width: 100%;" />
                    </a-form-model-item>
                </a-col>
                <!-- 状态 -->
                <a-col :span="4">
                    <a-form-model-item label="状态" prop="status">
                        <a-select v-model="formData.status">
                            <a-select-option value="正常">正常</a-select-option>
                            <a-select-option value="停用">停用</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <!-- 是否显示简介 -->
                <a-col :span="2">
                    <a-form-model-item label="显示简介" prop="showDesc">
                        <a-switch v-model="formData.showDesc" />
                    </a-form-model-item>
                </a-col>
                <!-- 是否显示导购 -->
                <a-col :span="2">
                    <a-form-model-item label="显示导购" prop="showSale">
                        <a-switch v-model="formData.showSale" />
                    </a-form-model-item>
                </a-col>
                <!-- 推荐 -->
                <a-col :span="2">
                    <a-form-model-item label="设为优选" prop="isRecommend">
                        <a-switch v-model="formData.isRecommend" />
                    </a-form-model-item>
                </a-col>
                <!-- 介绍 -->
                <a-col :span="24">
                    <a-form-model-item prop="description">
                        <!-- <editor v-model="formData.description" /> -->
                        <a-textarea v-model="formData.description" rows="4" :max-length="255" placeholder="请输入商户简介" />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>
</template>

<script>
import apiUtils from '@/common/apiUtil';
import utils from '@/common/utils';
import request from "@/config/request";
import uploadImages from '@/components/upload-images.vue';
import editor from '@/components/component/editor.vue';
import thumb from '@/components/thumb.vue';
export default {
    components: { uploadImages, editor, thumb },
    props: {
        categorys: {
            type: Array,
            default: () => []
        },
        areas: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visable: false,
            loading: false,
            formData: {
                storeId: '', // 店铺ID
                areaId: '', // 所在区域
                cateId: '', // 所属分类
                name: '', // 商户名称
                organId: apiUtils.getOrganId(), // 所属单位
                no: '', // 铺位号
                identifier: '', // 营业执照号码
                thumb: '', // 图片
                address: '', // 地址
                person: '', // 联系人
                phone: '', // 联系电话
                showDesc: true, // 是否显示简介
                description: '', // 简介
                brand: '', // 品牌
                brandLogo: '', // 品牌Logo
                showSale: true, // 是否显示导购
                saleMobile: [], // 导购员电话
                wechatApp: '', // 商家小程序AppID
                remark: '', // 备注
                status: '正常', // 状态
                guobuNum: 0,
                isRecommend: false, // 设为优选
                sort: 0, // 排序
            }
        };
    },
    methods: {
        doValidate() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                this.loading = true;
                request.post('/platform/store/save', this.formData).then(res => {
                    utils.success('保存成功').then(() => {
                        this.visable = false;
                        this.$emit('success');
                    });
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        show(data) {
            this.formData.storeId = '';
            this.visable = true;
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate();
                this.$refs.formRef.resetFields();
                if (data) {
                    this.formData = JSON.parse(JSON.stringify(data));
                }
            });
        }
    }

};
</script>

<style></style>